import { getImage } from "gatsby-plugin-image";
import { BgImage } from "gbimage-bridge";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "./Button"; // Custom Button component
import { SafeHtmlParser } from "./SafeHtmlParser";

const StatsLayout3 = ({
	heading,
	body,
	backgroundImage,
	stat1,
	stat2,
	stat3,
	stat4,
	button,
}) => {
	// Get the background image for the BgImage component
	const bgImage = backgroundImage ? getImage(backgroundImage) : null;

	// Combine stats into an array for easier mapping
	const stats = [stat1, stat2, stat3, stat4];

	return (
		<BgImage
			className="py-5 pb-lg-7 pt-md-10 position-relative"
			image={bgImage}
		>
			<div
				style={{
					background:
						"linear-gradient(180deg, rgba(0, 18, 33, 0.00) 0%, #001221 83.8%), linear-gradient(0deg, rgba(0, 48, 75, 0.25) 0%, rgba(0, 48, 75, 0.25) 100%)",
				}}
				className="position-absolute h-100 w-100 start-0 top-0"
			></div>
			<Container style={{ zIndex: 2 }} className="pt-lg-5 position-relative">
				{/* Heading */}
				<Row className="g-5 g-xl-7">
					<Col md={12} lg={6}>
						<h2 className="text-white display-5">{heading}</h2>
						<div className="text-white">
							<SafeHtmlParser htmlContent={body} />
						</div>
						{button && (
							<Row className="mt-4">
								<Col className="">
									<Button
										outlineTextColor="#fff"
										width="w-100 w-md-auto"
										colour="#fff" // Customize as needed
										text={button.title}
										link={button.url}
										isOutline={true}
									/>
								</Col>
							</Row>
						)}
					</Col>
					<Col md={12} lg={6} className="text-white">
						<Row className="g-3 g-lg-5">
							{stats.map(
								(stat, index) =>
									stat && (
										<Col
											style={{ minHeight: "100%" }}
											md={6}
											sm={12}
											key={index}
										>
											<div
												className="pe-lg-4 ps-lg-4  ps-3 h-100 text-white py-1"
												style={{
													borderLeft: "4px solid #fff",
												}}
											>
												<h3 className="display-2">{stat.heading}</h3>
												<p>{stat.body}</p>
											</div>
										</Col>
									)
							)}
						</Row>
					</Col>
				</Row>
			</Container>
		</BgImage>
	);
};

// Inline styles

export default StatsLayout3;
